import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites/theme-sandbox-theme/registry';

export const registry: ComponentRegistry = {
  ...parentRegistry,
};

export default registry;
